var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHyn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.761 1 .604.942 4.798 7.51-1.237.79-4.196-6.567-1.24 1.84-1.217-.82 1.863-2.767.625-.928zm-9.76 5.29h10.93v1.467H8.44l.896 1.689-1.296.688-1.468-2.766L6 6.29zm18.213-.226h-3.217v1.468h1.81l-3.16 4.534a5.42 5.42 0 0 0-8.51 6.58l-4.123 5.91-.804 1.154h4.623v-1.467H9.022l3.07-4.404a5.42 5.42 0 0 0 8.477-6.531l4.247-6.092.804-1.153h-1.407zm-1.165 6.387 2.145 2.824.306.403-.268.429-4.856 7.79-1.245-.776 4.588-7.36-1.84-2.42 1.17-.89zm1.56 13.26h1.22l-.571-1.077-1.468-2.767-1.298.688.896 1.688h-8.49v1.468h9.71zM16.069 31l-.603-.942-4.798-7.51 1.236-.79 4.197 6.567 1.238-1.84 1.218.82-1.863 2.767-.625.928zM8.78 19.55l-2.144-2.824-.306-.403.267-.429 4.856-7.79 1.245.776-4.587 7.36 1.84 2.42-1.169.89zm10.635-3.663a3.613 3.613 0 1 1-7.227 0 3.613 3.613 0 0 1 7.227 0z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyn);
export default __webpack_public_path__ + "static/media/HYN.07ffa4776bd153e6c86ba5eb52df6ea7.svg";
export { ForwardRef as ReactComponent };